import { useGraphEvent, useGraphInstance, Node, Edge, Cell } from "@antv/xflow"
import { setAllPortsVisibilityByNodeView } from "./helper"
import { getTagIdByNodeId } from "../nodes"
import { NodeShapes, UnitTagState } from "../services/modal"
import { useEditorEventBusInstance } from "./useEventBusInstance"
import { getLineCenter } from "../utils"

export const useNodeEvents = () => {
  const graph = useGraphInstance();
  const eventBus = useEditorEventBusInstance()

  useGraphEvent('node:resizing', ({ node }) => {

    const {width, height} = node.getSize()
    node.setData({ ...node.getData(), width, height })
  });
  
  useGraphEvent('node:mouseenter', ({ view, node}) => {
    if ([NodeShapes.SvgNode, NodeShapes.SvgStream].includes(node.shape as NodeShapes)) {
      setAllPortsVisibilityByNodeView(view, 'visible')
    }
  })

  useGraphEvent('node:mouseleave', ({ view }) => {
    setAllPortsVisibilityByNodeView(view, 'hidden')
  })

  useGraphEvent('node:unselected', () => {
    graph?.clearTransformWidgets()
  })

  useGraphEvent('cell:removed', ({ cell }: {cell: Cell}) => {
    if (cell.shape === NodeShapes.SvgNode || cell.shape === NodeShapes.Edge) {
      const tagId = getTagIdByNodeId(cell.id)
      const tagNode = graph!.getCellById(tagId);
      if (tagNode) graph?.removeCell(tagNode)
    } else if (cell.shape === NodeShapes.UnitTag) {
      const data = cell.getData() as UnitTagState
      const target = graph?.getCellById(data.unit) as Node
      target?.setData({...target.getData(), showTag: false})
    }
    eventBus.trigger('updateCell', cell)
  })

  const changeTagPosition = (node: Node) => {
    const position = node.getPosition()
    const tagNode = graph?.getCellById(getTagIdByNodeId(node.id)) as Node
    if (tagNode) {
      const tagData = tagNode.getData() as UnitTagState
      tagNode.setPosition({
        x: position.x + tagData.offset.x,
        y: position.y + tagData.offset.y,
      })
    }
  }

  useGraphEvent('node:change:position', ({node}: {node: Node}) => {
    if (node.shape === NodeShapes.SvgNode) {
      changeTagPosition(node);
    }
  })

  useGraphEvent('node:moving', ({ node }: {node: Node}) => {
    if (node.shape === NodeShapes.SvgNode) {
      changeTagPosition(node);
    } else if (node.shape === NodeShapes.UnitTag) {
      const nodeData = node.getData() as UnitTagState
      const parentNode = graph?.getCellById(nodeData.unit) as Node
      if (parentNode && graph?.isNode(parentNode)) {
        const parentPosition = parentNode.getPosition()
        const tagPosition = node.getPosition()
        const offset = {
          x: tagPosition.x - parentPosition.x,
          y: tagPosition.y - parentPosition.y,
        }
        node.setData({ ...node.getData(), offset })
      } else if (parentNode && graph?.isEdge(parentNode)) {
        const parentEdge = parentNode as Edge
        const center = getLineCenter(parentEdge, graph)
        if (center) {
          const tagPos = node.getPosition()
          node.setData({ ...node.getData(), offset: {x: tagPos.x - center.x, y: tagPos.y - center.y} })
        }
      }
    }
  })
}